import type { TOC } from '@ember/component/template-only'
import { and } from 'ember-truth-helpers'
import PageHeader from 'teacher-ui-client/components/page-header'
import FidgetSpinnerWave from '@blakeelearning/fidget/components/fidget/spinner/wave'
import { ErrorsUnexpected } from 'teacher-ui-client/components/errors/unexpected'
import type { TaskInstance } from 'ember-concurrency'

interface Signature {
  Element: HTMLDivElement
  Args: {
    title: string
    loaderInstance?: TaskInstance<unknown>
  }
  Blocks: {
    header: []
    banner: []
    results: []
  }
}

export const LessonsPage: TOC<Signature> = <template>
  <PageHeader>
    <:title>
      <h1>
        {{@title}}
      </h1>
    </:title>
  </PageHeader>
  <div class="space-y-6" ...attributes>
    {{yield to="header"}}
    {{yield to="banner"}}
    <div class="safari-gap-6 mx-auto flex max-w-(--breakpoint-2xl) flex-wrap items-stretch justify-center gap-6">
      {{#if (and @loaderInstance @loaderInstance.isRunning)}}
        <FidgetSpinnerWave data-test-loading @centered={{true}} />
      {{else if @loaderInstance.isSuccessful}}
        {{yield to="results"}}
      {{else}}
        <ErrorsUnexpected data-test-error />
      {{/if}}
    </div>
  </div>
</template>

export default LessonsPage
